export default __webpack_public_path__ + "static/media/grn-logo.431c2996.svg";